import React from 'react';
import { FaHeart } from 'react-icons/fa';

const Footer = ({ variant = 'light' }) => {
  const isDark = variant === 'dark';
  
  return (
    <footer className="py-6 relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center space-y-4">
          <div className="flex items-center text-sm font-medium tracking-wide uppercase">
            <span className={isDark ? "text-white/70" : "text-gray-600"}>Made with</span>
            <div className="relative mx-2">
              <FaHeart className={`w-5 h-5 ${isDark ? "text-white" : "text-pink-500"} animate-pulse`} />
              <div className={`absolute inset-0 blur-sm ${isDark ? "bg-white/30" : "bg-pink-500/30"} animate-pulse rounded-full`}></div>
            </div>
            <span className={isDark ? "text-white/70" : "text-gray-600"}>by</span>
            <a 
              href="https://this-person-does-not-exist.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className={`ml-2 transition-all duration-300 transform hover:scale-105 ${
                isDark ? "text-white hover:text-white/80" : "text-purple-600 hover:text-pink-600"
              }`}
            >
              Anonymous
            </a>
          </div>

          <div className={`text-xs uppercase tracking-widest ${isDark ? "text-white/60" : "text-gray-500"}`}>
            © {new Date().getFullYear()} Chithi.Pii
            <span className="mx-2">•</span> 
            All rights reserved
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 